import { createFileRoute, redirect } from '@tanstack/react-router';

const APPS_TO_SOFTWARE_REGEX = /^\/apps/;

export const Route = createFileRoute('/_staff/apps')({
  beforeLoad: ({ location }) => {
    let newPathname: string;

    // /apps/integrations の場合は /software/registry にリダイレクト
    if (location.pathname.startsWith('/apps/integrations')) {
      newPathname = location.pathname.replace(
        '/apps/integrations',
        '/software/registry',
      );
    } else {
      // その他の場合は /apps を /software に置き換え
      newPathname = location.pathname.replace(
        APPS_TO_SOFTWARE_REGEX,
        '/software',
      );
    }

    // クエリパラメータも引き継ぐ
    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.toString();
    const to = search ? `${newPathname}?${search}` : newPathname;

    throw redirect({ to });
  },
});
